<script>
    export default {
        data() {
            return {};
        },
    };
</script>

<template>
    <div class="messages_but">
        <button v-if="false" class="hidden-messages-toggle"><span></span></button>
        <div class="messages-wrapper">
            <div class="hidden-messages-list"></div>
        </div>
    </div>
</template>

<style lang="scss">
    .mag-header-events {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 40px;
        font-size: 20px;
        text-decoration: none;
        cursor: pointer;
        &__badge {
            position: absolute;
            top: 2px;
            right: 2px;
            background: #e78374;
            color: #fff;
            padding: 0 4px;
            font-size: 9px;
            height: 15px;
            min-width: 15px;
            line-height: 15px;
            border-radius: 10px;
            text-align: center;
        }
    }
</style>
